import { Button, Modal } from 'antd';
import React, { useState } from 'react';
import RichTextEditor, { createEmptyValue, createValueFromString } from 'react-rte';
import appColors from '../config/appColors';
import { EditNote, Delete } from '@mui/icons-material';
// import SearchIcon from "@mui/icons-material/Search";


const MyRichTextEditor = ({ edit = false, del = false, onDelete = () => { }, onSave = () => { }, val,submitButtonText = "Save", ...props }) => {

  const [editorValue, setEditorValue] = useState(val ? createValueFromString(val, 'html') : createEmptyValue());
  const [disabled, setDisabled] = useState(props.disabled ?? false);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const handleChange = (value) => {
    setEditorValue(value);
  };

  const handleSubmit = () => {
    console.log(editorValue.toString('html')); // Log HTML content
  };

  const customToolbarConfig = {
    // Define your custom toolbar configuration
    display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN'],
    INLINE_STYLE_BUTTONS: [
      { label: 'Bold', style: 'BOLD' },
      { label: 'Italic', style: 'ITALIC' },
      { label: 'Underline', style: 'UNDERLINE' }
    ],
    BLOCK_TYPE_DROPDOWN: [
      { label: 'Normal', style: 'unstyled' },
      { label: 'Heading Large', style: 'header-one' },
      { label: 'Heading Medium', style: 'header-two' },
      { label: 'Heading Small', style: 'header-three' }
    ],

    BLOCK_TYPE_BUTTONS: [
      { label: 'UL', style: 'unordered-list-item' },
      { label: 'OL', style: 'ordered-list-item' }
    ]
  };

  const saveCb = () => {
    if (props.disabled == true) {
      setDisabled(true);
    }


  }


  return (
    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column',  padding: 10, }}>
      <div style={{ width: "100%", display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <div style={{ width: edit ? "98%" : "100%" }}>
          <RichTextEditor
            {...props}
            disabled={disabled}
            toolbarConfig={customToolbarConfig}
            value={editorValue}
            onChange={handleChange}
            rootStyle={{minHeight:200}}
          />
        </div>
        <div style={{ marginLeft: 15 }}>
          {
            edit &&
            <>
              <div
                onClick={() => setDisabled(!disabled)}
                style={{ cursor: 'pointer', fontFamily: 'Poppins', fontSize: 14 ,marginTop:-5}}>
                {
                  !disabled ? "Cancel" : <EditNote />
                }
              </div>
            </>
          }
          {
            del && disabled &&
            <div
              onClick={() => setConfirmDelete(true)}
              style={{ cursor: 'pointer', marginTop:0, }}>
              <Delete style={{color:'red'}}  />
            </div>
          }
        </div>
      </div>
      <div style={{ display: 'flex', alignSelf: 'center', }}>
        {
          disabled ?
            null :
            <Button
              onClick={() => onSave(editorValue.toString('html'), saveCb())}
              style={{
                height: 40, backgroundColor: appColors.primary, marginTop: 20,
                fontFamily: 'Poppins', fontSize: 14, fontWeight: 600, width: 200,

              }}
              type="primary"
              htmlType="submit">

              {submitButtonText}
            </Button>
        }

      </div>


      <Modal
        title="Are you sure you want to delete this note?"
        visible={confirmDelete}
        onCancel={() => setConfirmDelete(false)}
        footer={[
          <Button key="cancel" onClick={() => setConfirmDelete(false)}>
            Cancel
          </Button>,
          <Button danger key="delete" onClick={() => {
            setConfirmDelete(false);
            onDelete()
          }}>
            Delete
          </Button>,
        ]}
      >
        <p>Deleting this note will parmanently delete. You will never recover this note.</p>
      </Modal>


    </div>
  );
};

export default MyRichTextEditor;



